<template>
    <ul>
        <li v-for="(content, index) in bullets" :key="index">
            <BaseText :text=content :textFromTextkey=textFromTextkey></BaseText>
        </li>
    </ul>
</template>

<script lang="ts" setup>
import BaseText from '@/components/base/BaseText.vue';

defineProps({
    bullets: {
        type: Array<string>,
        required: true
    },
    textFromTextkey: { type: Boolean, default: true },
});
</script>